import { render, staticRenderFns } from "./SiteStatsOverview.vue?vue&type=template&id=3716a772&scoped=true&"
import script from "./SiteStatsOverview.vue?vue&type=script&lang=js&"
export * from "./SiteStatsOverview.vue?vue&type=script&lang=js&"
import style0 from "./SiteStatsOverview.vue?vue&type=style&index=0&id=3716a772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3716a772",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardSubtitle,VCardTitle,VIcon,VSpacer})
